import { useSelector } from 'react-redux';
import isEqual from 'lodash/isEqual';
import { useEffect } from 'react';
import isFunction from 'lodash/isFunction';
import {
  selectTopProps,
  selectIsPayPalButtonAvailable,
  selectApplePayButtonAvailable,
  selectGooglePayButtonAvailable,
} from '../../selectors';

/**
 * Custom hook to trigger onPaymentMethodsAmountInit callback
 */
export const useOnPaymentMethodsAmountInit = () => {
  const { orderItems, onPaymentMethodsAmountInit } = useSelector(selectTopProps, (prev, next) => {
    return isEqual(prev.orderItems, next.orderItems);
  });
  const hasGooglePay = useSelector(selectGooglePayButtonAvailable);
  const hasPayPal = useSelector(selectIsPayPalButtonAvailable);
  const hasApplePay = useSelector(selectApplePayButtonAvailable);

  useEffect(() => {
    if (isFunction(onPaymentMethodsAmountInit)) {
      const amountOfAvailablePMs = [hasGooglePay, hasApplePay, hasPayPal].reduce((acc, el) => (el ? acc + 1 : acc), 0);
      onPaymentMethodsAmountInit(amountOfAvailablePMs);
    }
  }, [orderItems]);
};
